module.exports = __webpack_public_path__ + "themes/fq/img/logo-title@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/logo-title@2x.png
// module id = 2
// module chunks = b-loader d-game